<template>
    <footer id="page-footer">
        <div class="container text-center">
            <p>&copy; Nomad Office 2021</p>
            <p>
                <a href="mailto:help@nomadoffice.app">Contact Us</a>
                |
                <router-link to="/privacy">
                    Privacy Policy
                </router-link>
                |
                <router-link to="/terms">
                    Terms of Use
                </router-link>
            </p>
        </div>
    </footer>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'PageFooter',
});
</script>

<style lang="scss">
#page-footer {
    width: 100%;

    .container {
        padding-top: 30px;
        padding-bottom: 30px;
        color: #000;
        font-size: 14px;

        a {
            color: #000;
            display: inline-block;
            margin: 0 5px;
            font-weight: bold;
        }

        p {
            margin: 0;
            font-size: 13px;
        }
    }
}
</style>
